/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S4_HeadingInputs */

const tr_cerez_s4_heading = /** @type {(inputs: Cerez_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Süre Bakımından Türleri`)
};

const en_cerez_s4_heading = /** @type {(inputs: Cerez_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Types by duration`)
};

const de_cerez_s4_heading = /** @type {(inputs: Cerez_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Arten nach Dauer`)
};

const ru_cerez_s4_heading = /** @type {(inputs: Cerez_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Виды по сроку действия`)
};

/**
* | output |
* | --- |
* | "4. Types by duration" |
*
* @param {Cerez_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s4_heading = /** @type {((inputs?: Cerez_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s4_heading(inputs)
	if (locale === "de") return de_cerez_s4_heading(inputs)
	if (locale === "ru") return ru_cerez_s4_heading(inputs)
	return tr_cerez_s4_heading(inputs)
});